import React, { useState } from 'react';
import axios from 'axios';

const Contact = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      // Appel à ton API Node.js
      const response = await axios.post('http://localhost:5000/api/contact', formData);
      
      if (response.status === 200) {
        alert('Merci ! Votre message a bien été envoyé à l\'équipe de Fréquence 974.');
        setFormData({ name: '', email: '', subject: '', message: '' });
        e.target.reset();
      }
    } catch (error) {
      console.error("Erreur envoi formulaire:", error);
      alert("Une erreur est survenue. Veuillez réessayer plus tard.");
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  return (
    <div className="bg-light min-vh-100 pb-5">
      {/* HEADER DE LA PAGE AVEC TA PHRASE */}
      <div className="py-5 text-white text-center" style={{ background: 'linear-gradient(135deg, #002d5b 0%, #004a99 100%)', borderBottom: '4px solid #ffc107' }}>
        <div className="container">
          <h1 className="fw-black text-uppercase italic display-4 mb-2">Contactez-<span className="text-danger">Nous</span></h1>
          <p className="lead fw-bold mb-0">Une dédicace, une info ou un partenariat ? Écrivez-nous !</p>
          <p className="text-warning small text-uppercase fw-black tracking-widest mt-2" style={{ letterSpacing: '2px' }}>
            Nous sommes à votre écoute pour faire vibrer l'intensité de l'Océan Indien.
          </p>
        </div>
      </div>

      <div className="container mt-n4">
        <div className="row justify-content-center">
          <div className="col-lg-8">
            <div className="card border-0 shadow-lg rounded-5 overflow-hidden">
              <div className="p-4 p-md-5 bg-white">
                <form onSubmit={handleSubmit}>
                  <div className="row g-4">
                    <div className="col-md-6">
                      <label className="form-label small fw-black text-uppercase">Nom complet</label>
                      <input 
                        type="text" 
                        name="name"
                        className="form-control rounded-4 border-light bg-light py-3 px-4 shadow-none" 
                        placeholder="Votre nom" 
                        required 
                        value={formData.name}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-md-6">
                      <label className="form-label small fw-black text-uppercase">Email</label>
                      <input 
                        type="email" 
                        name="email"
                        className="form-control rounded-4 border-light bg-light py-3 px-4 shadow-none" 
                        placeholder="votre@email.com" 
                        required 
                        value={formData.email}
                        onChange={handleChange}
                      />
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-black text-uppercase">Sujet</label>
                      <select 
                        name="subject" 
                        className="form-select rounded-4 border-light bg-light py-3 px-4 shadow-none" 
                        required 
                        value={formData.subject}
                        onChange={handleChange}
                      >
                        <option value="">Sélectionnez un motif</option>
                        <option value="dedicace">Dédicace / Message antenne</option>
                        <option value="partenariat">Partenariat publicitaire</option>
                        <option value="technique">Problème technique</option>
                        <option value="autre">Autre demande</option>
                      </select>
                    </div>
                    <div className="col-12">
                      <label className="form-label small fw-black text-uppercase">Message</label>
                      <textarea 
                        name="message"
                        className="form-control rounded-4 border-light bg-light py-3 px-4 shadow-none" 
                        rows="5" 
                        placeholder="Écrivez votre message ici..." 
                        required 
                        value={formData.message}
                        onChange={handleChange}
                      ></textarea>
                    </div>
                    <div className="col-12 text-center mt-4">
                      <button type="submit" className="btn btn-warning w-100 rounded-pill py-3 fw-black text-uppercase shadow-lg transition-all hover-scale">
                        <i className="bi bi-send-fill me-2"></i> Envoyer au studio
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            {/* Rappel des réseaux en bas du formulaire */}
            <div className="text-center mt-4">
               <p className="small fw-bold text-uppercase text-secondary mb-3">Retrouvez-nous aussi sur</p>
               <div className="d-flex justify-content-center gap-3">
                  <a href="#" className="btn btn-dark rounded-circle shadow-sm"><i className="bi bi-facebook"></i></a>
                  <a href="#" className="btn btn-dark rounded-circle shadow-sm"><i className="bi bi-tiktok"></i></a>
                  <a href="#" className="btn btn-dark rounded-circle shadow-sm"><i className="bi bi-instagram"></i></a>
               </div>
            </div>
          </div>
        </div>
      </div>

      <style>{`
        .fw-black { font-weight: 900; }
        .italic { font-style: italic; }
        .mt-n4 { margin-top: -3rem; }
        .hover-scale:hover { transform: scale(1.01); filter: brightness(1.05); }
        .transition-all { transition: all 0.3s ease; }
        input:focus, textarea:focus, select:focus {
          background-color: #fff !important;
          border-color: #ffc107 !important;
          box-shadow: 0 0 0 0.25rem rgba(255, 193, 7, 0.1) !important;
        }
      `}</style>
    </div>
  );
};

export default Contact;